<template>
  <div class="mb-3">
    <label class="form-label">{{ label }}</label>
    <div class="form-icon position-relative">
      <select
        name="readiness_to_leave"
        :value="modelValue"
        @input="updateValue"
        class="form-select"
      >
        <option
          v-for="(value, key) in data"
          :key="key"
          :value="value.slug"
        >
          {{ value.name }}
        </option>
      </select>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "ProfileSlug",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    data: {
      type: Object,
      required: false,
      default: {},
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>